export default __webpack_public_path__ + "img/heart-selected.954de53d.svg";